import React, { useEffect, useRef } from "react";
import "./ModuleWorkspace.css";

export function ModuleWorkspace({
  ariaLabel,
  header,
  list,
  detail,
  detailKey,
  single,
  detailOpen = false,
  onBackToList,
  backLabel = "Volver a equipos",
}) {
  const detailRef = useRef(null);

  useEffect(() => {
    if (detailRef.current) detailRef.current.scrollTop = 0;
  }, [detailKey]);

  return (
    <section className="module-workspace" aria-label={ariaLabel}>
      {header ? <div className="module-workspace__header">{header}</div> : null}

      {single ? (
        <div className="module-workspace__single">{single}</div>
      ) : (
        <div
          className={`module-workspace__body ${detailOpen ? "is-detail-open" : ""}`}
        >
          <div className="module-workspace__list" aria-label="Listado">
            {list}
          </div>

          <div
            className="module-workspace__detail"
            aria-label="Detalle"
            ref={detailRef}
          >
            <div className="module-workspace__mobile-back">
              <button
                className="button secondary"
                type="button"
                onClick={onBackToList}
              >
                ← {backLabel}
              </button>
            </div>
            {detail}
          </div>
        </div>
      )}
    </section>
  );
}
